import {mediaMatch} from "../utils";
import cookies from "../utils/cookies";
import store from "../reducer/store";
import {setDrawerLogin} from "../reducer/actions";
import {useNavigate} from "react-router";

const authPages = [
  '/confirmOrder',
  '/orderList',
  '/orderDetail',
  '/myCoupon',
  '/bookinglist',
  '/myIntegral',
  '/myBooking',
  '/shippingAddress',
  '/messageCenter'
];


const useNavigateTo = () => {
  const navigate = useNavigate();
  const isMdmax = mediaMatch.isMdmax;
  
  const navigateTo = (path, config = {}) => {
    if (authPages.includes(path) && !cookies.getToken()) {
      if (isMdmax) {
        navigate(`/login?redirect=${path}`, { replace: true });
      } else {
        
        if (cookies.get('MALL') === '7') {
          store.dispatch(setDrawerLogin(true));
        } else {
          navigate('/login');
        }
        
      }
    } else {
      navigate(path, config);
    }
  };
  
  return navigateTo;
};

export {useNavigateTo, authPages};
